//criar funcionalidade de autenticação
import PouchDB from "pouchdb-browser"
import PouchAuth from "pouchdb-authentication"
import { UserAuth } from "../config/data.types";
import { db } from "./db";


PouchDB.plugin(PouchAuth);

const baseUrl = process.env.PARCEL_BASE_URL;
const baseAuth = process.env.PARCEL_BASE_AUTH;

console.log("ambiente vars",process.env.PARCEL_BASE_URL,process.env.PARCEL_BASE_AUTH,process.env.PARCEL_DB_NAME,process.env.PARCEL_USER_NAME,process.env.PARCEL_USER_PASS,process.env.PARCEL_USER_ADMIN);
type AuthResult = {status:"ok",row:UserAuth} | {status:"error",mensagem:string};
export const auth = {
    db: new PouchDB(baseUrl + baseAuth, { skip_setup: true }),
    /*async signin(login:string,pass:string):Promise<AuthResult>{
        try {
            const resp = await auth.db.logIn(login, pass, {fetch: (url, opts) => fetch(url, { ...opts, credentials: 'include'  })});        
            if(resp.ok){
                //buscar metadados do usuario
                const respUser = await auth.db.getUser(resp.name);
                console.log("respUser",resp);
                const user = respUser as UserAuth;
                //gravar usuario no storage local, caso esteja ativo
                if(user.metadados.active){
                    localStorage.setItem("user", JSON.stringify(user));
                    //salvar a senha criptografada
                    localStorage.setItem("user_pass", btoa(pass));
                    db.connect({
                        db:user.metadados.db_name,
                        login:user.name,
                        pass:pass
                    })
                    return {status:"ok",row:user}
                } else {
                    return { status: "error", mensagem: "Sua empresa não está autorizada a usar o aplicativo, entre em contato com o suporte!"};
                }
            } else {
                return { status: "error", mensagem: "Error desconhecido, tente outra vez!"};
            }
        } catch (error:any) {
            console.log("ERROR LOGIN",error);
            let msg:string = "Verifique sua conexão.";
            if(error.status === 403)
                msg = "Esse usuário não esta autorizado a acessar o aplicativo. "
            if(error.status === 401)
                msg = "Email de usuário ou senha está incorreto, tente outra vez. "
            return {status:"error",mensagem: msg+error.error}
        }   
    },*/

    async logIn(login: string, pass: string): Promise<{status: "ok", row: UserAuth} | {status: "error", mensagem: string, statusError?: number}> {
        try {
            const resp = await fetch(baseUrl + "_session", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: 'include', // Incluir cookies na requisição
                body: JSON.stringify({ name: login, password: pass })
            });
            console.log("resp _session", resp);
            if (resp.ok && resp.status === 200) {
                //buscar metadados do usuario
                const respUser = await fetch(baseUrl + baseAuth + "/org.couchdb.user:" + login, {
                    method: "GET",
                    headers: { 'Accept': 'application/json' },
                    credentials: 'include' // Incluir cookies na requisição
                });
                console.log("respUser", respUser);
                const user = await respUser.json() as UserAuth;
                //gravar usuario no storage local, caso esteja ativo
                if (user.metadados.active) {
                    localStorage.setItem("credencial", JSON.stringify(user));
                    //salvar a senha criptografada
                    localStorage.setItem("credencial_pass", btoa(pass));
                    db.connect({
                        db: user.metadados.db_name,
                        login: user.name,
                        pass: pass
                    })
                    return { status: "ok", row: user }
                } else {
                    return { status: "error", mensagem: "Sua credencial não está autorizada a usar o aplicativo, entre em contato com o suporte!" };
                }
            } else {
                return { status: "error", mensagem: JSON.stringify(resp) };
            }
        } catch (error: any) {
            console.log("ERROR LOGIN", error);
            var msg: string = "";
            if( typeof error === 'object') {
                msg = JSON.stringify(error.message);
            } else {
                msg = String(error);
            }
            if (error.status === 403)
                msg = "Esse usuário não esta autorizado a acessar o aplicativo. "
            if (error.status === 401)
                msg = "Email de usuário ou senha está incorreto, tente outra vez. "
            return { status: "error", mensagem: msg, statusError:error.status }
        }
    },    

    async singInFast():Promise<AuthResult>{
        try {
            let userString = localStorage.getItem("credencial");
            let passString = localStorage.getItem("credencial_pass");
            if (userString && passString) {
                let userObj: UserAuth = JSON.parse(userString);
                let pass = atob(passString);
                let respLogin = await auth.logIn(userObj.name, pass);
                //verificar o statusError se for acima de 500, provavelmente o problema é na rede ou no servidor
                //se for esse erro os dados de usuario serao o que esta no localStorage.
                if (respLogin.status === "error" && respLogin.statusError && respLogin.statusError >= 500) {
                    db.connect({
                        db: userObj.metadados.db_name,
                        login: userObj.name,
                        pass: pass
                    })                    
                    return { status: "ok", row: userObj };
                } else {
                    if(respLogin.status === "ok") {
                        return { status: "ok", row: respLogin.row };
                    } else {
                        return { status: "error", mensagem: respLogin.mensagem };
                    }
                }
            } else {
                return { status: "error", mensagem: "Nenhum credencial logado" };
            }
        } catch (error: any) {
            console.log("ERROR SINGINFAST", error);
            return { status: "error", mensagem: "Erro ao recuperar credencial logada: " + error.message };
        }

    },
    async logOut(): Promise<AuthResult> {
        try {
            localStorage.removeItem("credencial");
            localStorage.removeItem("credencial_pass");
            await db.disconnectDb();
            return { status: "ok", row: null as any };
        } catch (error: any) {
            console.log("ERROR LOGOUT", error);
            return { status: "error", mensagem: "Erro ao fazer logout: " + error.message };
        }
    },    
}